// extracted by mini-css-extract-plugin
export default {"button":"TypeSelectButton__button--3PjGk","selected":"TypeSelectButton__selected--1c3jf","icon":"TypeSelectButton__icon--1DgTt"};